// extracted by mini-css-extract-plugin
export default {"galleryItem":"c-n_gf","galleryItem_borderTopRadius":"c-n_gg","galleryItem__image":"c-n_gh","galleryItem__image_withBlur":"c-n_gi"};